import { TReduxActions } from '../../../types/redux';
import { ETransportActionTypes } from '../../../actions/newReview';
import { TTransportRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: 0,
};

export function transportRatingReducer(
  state: TTransportRating = defaultValue,
  { type, payload }: TReduxActions,
): TTransportRating {
  if (type === ETransportActionTypes.SetRating) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
